import { User } from "@/declare/interface/project/user";
import { StdResponse, coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
/**
 * 验证用户是否登录（通过请求头中的信息进行登陆验证）
 * @returns Promise 解析为 StdResponse，包含用户登录状态
 */
export function userCheckLogin(params?: {}): Promise<StdResponse<any>> {
    return coreAxios.get(`/users/check-login`, {
        params: params
    })
}
/**
 * 用户登录
 * @param user 用户信息
 * - username: 用户名
 * - password: 用户密码
 * @returns Promise 解析为 StdResponse，包含用户详细信息
 */
export function userLogin(user: User, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.post(`/users/login`, user, {
        params: params
    })
}
/**
 * 根据用户ID获取用户信息
 * @param userId 用户ID
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function getUser(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users/${userId}`, {
        params: {
            params,
        }
    })
}

/**
 * 获取用户信息列表
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function getUsers(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/users`, {
        params: {
            ...params,
        }
    })
}
/**
 * 根据用户Uuid修改用户信息
 * @param userUuid 用户Uuid
 * @param user 用户信息（名称、用户名、密码、类型、电话、邮箱、冻结状态、组织、职位）
 * @returns Promise 解析为 AxiosResponse，包含用户信息
 */
export function changeUser(userUuid: string, user: User, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/users/${userUuid}`, user, {
        params: {
            params,
        }
    })
}

/**
 * 添加用户
 * 
 * @param user 用户信息
 *             - username: 用户名
 *             - password: 密码
 *             - type: 用户类型
 * @return 用户ID
 */
export function addUser(user: User, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/users`, user, {
        params: {
            params,
        }
    })
}
